/**
 * Premium Mobile Enhancements
 * Sticky Add to Cart Bar for Mobile Product Pages
 */

class StickyAddToCart {
  constructor() {
    this.bar = document.querySelector('.sticky-atc-bar');
    if (!this.bar) return;

    this.productForm = document.querySelector('form[action*="/cart/add"]');
    this.productImage = document.querySelector('.product__media img');
    this.productTitle = document.querySelector('.product__title');
    this.productPrice = document.querySelector('.price');

    if (!this.productForm) return;

    this.init();
  }

  init() {
    // Populate sticky bar with product info
    if (this.productImage) {
      const stickyImage = this.bar.querySelector('.sticky-atc-bar__image');
      if (stickyImage) {
        stickyImage.src = this.productImage.src;
        stickyImage.alt = this.productImage.alt;
      }
    }

    if (this.productTitle) {
      const stickyTitle = this.bar.querySelector('.sticky-atc-bar__title');
      if (stickyTitle) {
        stickyTitle.textContent = this.productTitle.textContent;
      }
    }

    if (this.productPrice) {
      const stickyPrice = this.bar.querySelector('.sticky-atc-bar__price');
      if (stickyPrice) {
        stickyPrice.textContent = this.productPrice.textContent;
      }
    }

    // Show/hide based on scroll position
    this.handleScroll();
    window.addEventListener('scroll', () => this.handleScroll());

    // Handle add to cart from sticky bar
    const stickyButton = this.bar.querySelector('.sticky-atc-bar__button');
    if (stickyButton) {
      stickyButton.addEventListener('click', (e) => {
        e.preventDefault();
        const submitButton = this.productForm.querySelector('[type="submit"]');
        if (submitButton) {
          submitButton.click();
        }
      });
    }
  }

  handleScroll() {
    if (!this.productForm) return;

    const formRect = this.productForm.getBoundingClientRect();
    const isFormAboveViewport = formRect.bottom < 0;
    const isFormBelowViewport = formRect.top > window.innerHeight;

    if (isFormAboveViewport || isFormBelowViewport) {
      this.bar.classList.add('visible');
    } else {
      this.bar.classList.remove('visible');
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new StickyAddToCart();
  });
} else {
  new StickyAddToCart();
}

/**
 * Recently Viewed Products
 * Track and display recently viewed products
 */
class RecentlyViewedProducts {
  constructor() {
    this.storageKey = 'scg_recently_viewed';
    this.maxProducts = 8;
  }

  addProduct(productHandle, productData) {
    let recentlyViewed = this.getProducts();

    // Remove if already exists
    recentlyViewed = recentlyViewed.filter(p => p.handle !== productHandle);

    // Add to beginning
    recentlyViewed.unshift({
      handle: productHandle,
      title: productData.title,
      image: productData.image,
      price: productData.price,
      url: productData.url,
      timestamp: Date.now()
    });

    // Keep only max products
    recentlyViewed = recentlyViewed.slice(0, this.maxProducts);

    // Save
    try {
      localStorage.setItem(this.storageKey, JSON.stringify(recentlyViewed));
    } catch (e) {
      console.error('Error saving recently viewed:', e);
    }
  }

  getProducts() {
    try {
      const data = localStorage.getItem(this.storageKey);
      return data ? JSON.parse(data) : [];
    } catch (e) {
      console.error('Error reading recently viewed:', e);
      return [];
    }
  }

  clearProducts() {
    try {
      localStorage.removeItem(this.storageKey);
    } catch (e) {
      console.error('Error clearing recently viewed:', e);
    }
  }
}

// Make available globally
window.RecentlyViewedProducts = new RecentlyViewedProducts();

/**
 * Color Swatch Interactions
 */
document.addEventListener('DOMContentLoaded', () => {
  const colorSwatches = document.querySelectorAll('.color-swatch');

  colorSwatches.forEach(swatch => {
    swatch.addEventListener('click', function() {
      // Remove active from siblings
      const siblings = this.parentElement.querySelectorAll('.color-swatch');
      siblings.forEach(s => s.classList.remove('active'));

      // Add active to clicked
      this.classList.add('active');

      // Trigger variant change if connected
      const variantId = this.dataset.variantId;
      if (variantId) {
        const variantInput = document.querySelector(`input[value="${variantId}"]`);
        if (variantInput) {
          variantInput.checked = true;
          variantInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
  });
});

/**
 * Filter Pills Interaction
 */
document.addEventListener('DOMContentLoaded', () => {
  const filterPills = document.querySelectorAll('.filter-pill');

  filterPills.forEach(pill => {
    pill.addEventListener('click', function(e) {
      // Don't toggle if clicking remove button
      if (e.target.closest('.filter-pill__remove')) {
        return;
      }

      this.classList.toggle('active');

      // Trigger filter if connected
      const filterValue = this.dataset.filterValue;
      if (filterValue) {
        // Handle filter logic here or trigger Shopify's facet system
        console.log('Filter toggled:', filterValue);
      }
    });

    // Remove pill
    const removeBtn = pill.querySelector('.filter-pill__remove');
    if (removeBtn) {
      removeBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        pill.remove();
      });
    }
  });
});

/**
 * Smooth scroll behavior for anchor links
 */
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    const href = this.getAttribute('href');
    if (href === '#' || href === '#!') return;

    const target = document.querySelector(href);
    if (target) {
      e.preventDefault();
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  });
});
